import {useTranslation} from 'react-i18next';

import {Button} from '@/components/ui/button';
import type {DialogProps} from '@/components/ui/dialog';
import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogSection,
  DialogTitle,
} from '@/components/ui/dialog';
import {cn} from '@/utils/ui';

import {Typography} from '../ui/typography';

export type ConfirmDialogProps = DialogProps & {
  onClose: (open: boolean) => void; // backwards compatibility
  onConfirm: () => void;
  title?: string;
  message?: string;
  isWarning?: boolean;
};

const ConfirmDialog = ({
  onClose,
  onConfirm,
  title,
  message,
  isWarning,
  ...props
}: ConfirmDialogProps) => {
  const {t} = useTranslation();

  return (
    <Dialog {...props} onOpenChange={onClose}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{title || t('Are you sure?')}</DialogTitle>
        </DialogHeader>
        <DialogSection>
          <Typography className={cn({'text-red-500': isWarning})}>
            {message || t('Are you sure you want to continue?')}
          </Typography>
        </DialogSection>
        <DialogFooter>
          <Button
            type="button"
            variant="secondary"
            onClick={() => {
              onClose(false);
            }}
          >
            {t('Close')}
          </Button>
          <Button
            variant="primary"
            type="button"
            onClick={() => {
              onConfirm();
            }}
          >
            {t('Confirm')}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default ConfirmDialog;
